import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import copyApiImage from "../../../assets/ImageEditing/images/image-editing-overview.png";
import DemoIcon from "../../../assets/common/icons/demo.svg";
import IframeIcon from "../../../assets/common/icons/enable-iframe.svg";
import APIIcon from "../../../assets/common/icons/integrate-api.svg";
import SourceCodeIcon from "../../../assets/common/icons/source-code.svg";
import ConsoleOverviewCards, { OverviewCardType } from "../../../components/Home/Overview/Cards/ConsoleOverviewCards";
import ConsoleOverviewLayout from "../../../components/Home/Overview/Layout/ConsoleOverviewLayout";
import RouterConstants from "../../../constants/RouterConstants";
import { useLogEvents } from "../../../hooks/useLogEvents";

const ImageEditingOverview = () => {
	const { t } = useTranslation("translation", { keyPrefix: "imageEditing.overview" });
	const {
		logImageEditingMcpSidebarClick,
		logImageEditingFigmaClick,
		logImageEditingPhotoshopClick,
		logImageEditingFigmaPluginDownload,
		logImageEditingPhotoshopGoToMarketplace,
		logImageEditingComfyUSidebarClick,
	} = useLogEvents();

	const cards: OverviewCardType[] = [
		{
			icon: APIIcon,
			title: t("cards.api.title"),
			description: t("cards.api.description"),
			link: RouterConstants.IMAGE_EDITING.API.fullPath,
		},
		{
			icon: DemoIcon,
			title: t("cards.demo.title"),
			description: t("cards.demo.description"),
			link: RouterConstants.IMAGE_EDITING.DEMO.fullPath,
		},
		{
			icon: IframeIcon,
			title: t("cards.iframe.title"),
			description: t("cards.iframe.description"),
			link: RouterConstants.ACCOUNT_IFRAMES.fullPath,
		},
		{
			icon: SourceCodeIcon,
			title: t("cards.sourceCode.title"),
			description: t("cards.sourceCode.description"),
			link: RouterConstants.MODELS.fullPath,
		},
	];

	return (
		<ConsoleOverviewLayout
			copyApiTokenProps={{
				image: copyApiImage,
				description: t("copyApiToken.description"),
			}}
			integrations={["MCP_EDITING", "COMFY_UI", "FIGMA", "PHOTOSHOP", "FAL", "REPLICATE"]}
			pageName="imageEditing.overview"
			onMcpClick={logImageEditingMcpSidebarClick}
			onFigmaClick={logImageEditingFigmaClick}
			onPhotoshopClick={logImageEditingPhotoshopClick}
			onFigmaPluginDownload={logImageEditingFigmaPluginDownload}
			onPhotoshopPluginDownload={logImageEditingPhotoshopGoToMarketplace}
			onComfyUClick={logImageEditingComfyUSidebarClick}
		>
			<ConsoleOverviewCards cards={cards} />
		</ConsoleOverviewLayout>
	);
};

export default observer(ImageEditingOverview);
